import { formatName, TYPE_COLORS } from '../utils/pokemon';

function TypeBadge({ type }) {
  const [background, color] = TYPE_COLORS[type] || ['#6a5e52', '#fffaf3'];
  return (
    <span
      className="type-badge"
      style={{ '--type-bg': background, '--type-fg': color }}
    >
      {formatName(type)}
    </span>
  );
}

export default TypeBadge;
